import { render, staticRenderFns } from "./LxPagination.vue?vue&type=template&id=62354eb5&scoped=true"
import script from "./LxPagination.vue?vue&type=script&lang=js"
export * from "./LxPagination.vue?vue&type=script&lang=js"
import style0 from "./LxPagination.vue?vue&type=style&index=0&id=62354eb5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62354eb5",
  null
  
)

export default component.exports